<div class="pt-4 flex flex-col" [ngClass]="isCollapsed ? '' : 'wrapper'">
  <div *ngIf="!isCollapsed" class="flex justify-center">
    <img
      src="assets/images/logo.svg"
      alt="image"
      class="horizontal-separator mb-8 pb-2 w-3/5"
      [routerLink]="['/']"
    />
  </div>
  <div *ngIf="isCollapsed" class="flex justify-center">
    <img
      src="assets/icons/anyo-icon.svg"
      alt="image"
      class="horizontal-separator mb-8 pb-2"
      [routerLink]="['/']"
    />
  </div>
  <div>
    <div
      class="arrowBtn"
      [ngClass]="isCollapsed ? 'position-collapsed' : 'position-expanded'"
      (click)="collapse()"
    >
      <span class="arrow"></span>
    </div>
  </div>
  <ul nz-menu nzMode="inline" nzTheme="light" [nzInlineCollapsed]="isCollapsed">
    @for (item of menuArray; track item.name) {
      @if (item.name === "Dashboard") {
        <li
          nz-menu-item
          [nzSelected]="item.isSelected"
          class="!flex !items-center"
          [routerLink]="['/']"
        >
          <span nz-icon nzType="appstore"></span>
          <span>{{ item.name }}</span>
        </li>
      } @else {
        <li nz-submenu [nzTitle]="item.name" [nzIcon]="item.nzIcon!">
          <ul *ngFor="let subMenu of item.subMenu; index as i">
            <li
              *ngIf="!subMenu.subMenu"
              [nzSelected]="subMenu.isSelected"
              nz-menu-item
              [routerLink]="[subMenu.link]"
            >
              {{ subMenu.name }}
            </li>
            <li
              *ngIf="subMenu.subMenu && subMenu.subMenu.length"
              nz-submenu
              [nzTitle]="subMenu.name"
              nzIcon="sliders"
            >
              <ul *ngFor="let subMenu of subMenu.subMenu; index as i">
                <li
                  nz-menu-item
                  [nzSelected]="subMenu.isSelected"
                  [routerLink]="[subMenu.link]"
                >
                  {{ subMenu.name }}
                </li>
              </ul>
            </li>
          </ul>
        </li>
      }
    }
  </ul>
</div>
